export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: true
      , allEventsLinkText: 'VIEW FULL SCHEDULE'
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: false
      , buyNowButton: {visible: false, text: ''}
      , moreButton: {visible: false, text: ''}
      , maxItemsVisible: 5
      , isResponsive: false
      , hasDescription: false
      , textContainer: false
      , link: 'all'
      , attributeOrder: {
        1: 'date',
        2: 'title',
        3: 'image',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        $('.all-events-btn').addClass('button');

        $('#multiScheduleFeature .featureItem').each(function() {
          const itemTitle = $(this).find('.featureItemTitle');
          const characterLimit = 30;
          const itemTitleText = itemTitle.text();

          if ( itemTitleText.length > characterLimit ) {
            const trimmedText = itemTitleText.substring(0,characterLimit) + '...';
            itemTitle.text(trimmedText);
          }
        });
      }
  });

};

